var _asyncToGenerator = require("/opt/build/repo/node_modules/@babel/runtime/helpers/asyncToGenerator.js");

var _inherits = require("/opt/build/repo/node_modules/@babel/runtime/helpers/inherits.js");

var _possibleConstructorReturn = require("/opt/build/repo/node_modules/@babel/runtime/helpers/possibleConstructorReturn.js");

var _getPrototypeOf = require("/opt/build/repo/node_modules/@babel/runtime/helpers/getPrototypeOf.js");

var _classCallCheck = require("/opt/build/repo/node_modules/@babel/runtime/helpers/classCallCheck.js");

var _createClass = require("/opt/build/repo/node_modules/@babel/runtime/helpers/createClass.js");

function _regeneratorRuntime() { "use strict"; /*! regenerator-runtime -- Copyright (c) 2014-present, Facebook, Inc. -- license (MIT): https://github.com/facebook/regenerator/blob/main/LICENSE */ _regeneratorRuntime = function _regeneratorRuntime() { return exports; }; var exports = {}, Op = Object.prototype, hasOwn = Op.hasOwnProperty, $Symbol = "function" == typeof Symbol ? Symbol : {}, iteratorSymbol = $Symbol.iterator || "@@iterator", asyncIteratorSymbol = $Symbol.asyncIterator || "@@asyncIterator", toStringTagSymbol = $Symbol.toStringTag || "@@toStringTag"; function define(obj, key, value) { return Object.defineProperty(obj, key, { value: value, enumerable: !0, configurable: !0, writable: !0 }), obj[key]; } try { define({}, ""); } catch (err) { define = function define(obj, key, value) { return obj[key] = value; }; } function wrap(innerFn, outerFn, self, tryLocsList) { var protoGenerator = outerFn && outerFn.prototype instanceof Generator ? outerFn : Generator, generator = Object.create(protoGenerator.prototype), context = new Context(tryLocsList || []); return generator._invoke = function (innerFn, self, context) { var state = "suspendedStart"; return function (method, arg) { if ("executing" === state) throw new Error("Generator is already running"); if ("completed" === state) { if ("throw" === method) throw arg; return doneResult(); } for (context.method = method, context.arg = arg;;) { var delegate = context.delegate; if (delegate) { var delegateResult = maybeInvokeDelegate(delegate, context); if (delegateResult) { if (delegateResult === ContinueSentinel) continue; return delegateResult; } } if ("next" === context.method) context.sent = context._sent = context.arg;else if ("throw" === context.method) { if ("suspendedStart" === state) throw state = "completed", context.arg; context.dispatchException(context.arg); } else "return" === context.method && context.abrupt("return", context.arg); state = "executing"; var record = tryCatch(innerFn, self, context); if ("normal" === record.type) { if (state = context.done ? "completed" : "suspendedYield", record.arg === ContinueSentinel) continue; return { value: record.arg, done: context.done }; } "throw" === record.type && (state = "completed", context.method = "throw", context.arg = record.arg); } }; }(innerFn, self, context), generator; } function tryCatch(fn, obj, arg) { try { return { type: "normal", arg: fn.call(obj, arg) }; } catch (err) { return { type: "throw", arg: err }; } } exports.wrap = wrap; var ContinueSentinel = {}; function Generator() {} function GeneratorFunction() {} function GeneratorFunctionPrototype() {} var IteratorPrototype = {}; define(IteratorPrototype, iteratorSymbol, function () { return this; }); var getProto = Object.getPrototypeOf, NativeIteratorPrototype = getProto && getProto(getProto(values([]))); NativeIteratorPrototype && NativeIteratorPrototype !== Op && hasOwn.call(NativeIteratorPrototype, iteratorSymbol) && (IteratorPrototype = NativeIteratorPrototype); var Gp = GeneratorFunctionPrototype.prototype = Generator.prototype = Object.create(IteratorPrototype); function defineIteratorMethods(prototype) { ["next", "throw", "return"].forEach(function (method) { define(prototype, method, function (arg) { return this._invoke(method, arg); }); }); } function AsyncIterator(generator, PromiseImpl) { function invoke(method, arg, resolve, reject) { var record = tryCatch(generator[method], generator, arg); if ("throw" !== record.type) { var result = record.arg, value = result.value; return value && "object" == typeof value && hasOwn.call(value, "__await") ? PromiseImpl.resolve(value.__await).then(function (value) { invoke("next", value, resolve, reject); }, function (err) { invoke("throw", err, resolve, reject); }) : PromiseImpl.resolve(value).then(function (unwrapped) { result.value = unwrapped, resolve(result); }, function (error) { return invoke("throw", error, resolve, reject); }); } reject(record.arg); } var previousPromise; this._invoke = function (method, arg) { function callInvokeWithMethodAndArg() { return new PromiseImpl(function (resolve, reject) { invoke(method, arg, resolve, reject); }); } return previousPromise = previousPromise ? previousPromise.then(callInvokeWithMethodAndArg, callInvokeWithMethodAndArg) : callInvokeWithMethodAndArg(); }; } function maybeInvokeDelegate(delegate, context) { var method = delegate.iterator[context.method]; if (undefined === method) { if (context.delegate = null, "throw" === context.method) { if (delegate.iterator.return && (context.method = "return", context.arg = undefined, maybeInvokeDelegate(delegate, context), "throw" === context.method)) return ContinueSentinel; context.method = "throw", context.arg = new TypeError("The iterator does not provide a 'throw' method"); } return ContinueSentinel; } var record = tryCatch(method, delegate.iterator, context.arg); if ("throw" === record.type) return context.method = "throw", context.arg = record.arg, context.delegate = null, ContinueSentinel; var info = record.arg; return info ? info.done ? (context[delegate.resultName] = info.value, context.next = delegate.nextLoc, "return" !== context.method && (context.method = "next", context.arg = undefined), context.delegate = null, ContinueSentinel) : info : (context.method = "throw", context.arg = new TypeError("iterator result is not an object"), context.delegate = null, ContinueSentinel); } function pushTryEntry(locs) { var entry = { tryLoc: locs[0] }; 1 in locs && (entry.catchLoc = locs[1]), 2 in locs && (entry.finallyLoc = locs[2], entry.afterLoc = locs[3]), this.tryEntries.push(entry); } function resetTryEntry(entry) { var record = entry.completion || {}; record.type = "normal", delete record.arg, entry.completion = record; } function Context(tryLocsList) { this.tryEntries = [{ tryLoc: "root" }], tryLocsList.forEach(pushTryEntry, this), this.reset(!0); } function values(iterable) { if (iterable) { var iteratorMethod = iterable[iteratorSymbol]; if (iteratorMethod) return iteratorMethod.call(iterable); if ("function" == typeof iterable.next) return iterable; if (!isNaN(iterable.length)) { var i = -1, next = function next() { for (; ++i < iterable.length;) { if (hasOwn.call(iterable, i)) return next.value = iterable[i], next.done = !1, next; } return next.value = undefined, next.done = !0, next; }; return next.next = next; } } return { next: doneResult }; } function doneResult() { return { value: undefined, done: !0 }; } return GeneratorFunction.prototype = GeneratorFunctionPrototype, define(Gp, "constructor", GeneratorFunctionPrototype), define(GeneratorFunctionPrototype, "constructor", GeneratorFunction), GeneratorFunction.displayName = define(GeneratorFunctionPrototype, toStringTagSymbol, "GeneratorFunction"), exports.isGeneratorFunction = function (genFun) { var ctor = "function" == typeof genFun && genFun.constructor; return !!ctor && (ctor === GeneratorFunction || "GeneratorFunction" === (ctor.displayName || ctor.name)); }, exports.mark = function (genFun) { return Object.setPrototypeOf ? Object.setPrototypeOf(genFun, GeneratorFunctionPrototype) : (genFun.__proto__ = GeneratorFunctionPrototype, define(genFun, toStringTagSymbol, "GeneratorFunction")), genFun.prototype = Object.create(Gp), genFun; }, exports.awrap = function (arg) { return { __await: arg }; }, defineIteratorMethods(AsyncIterator.prototype), define(AsyncIterator.prototype, asyncIteratorSymbol, function () { return this; }), exports.AsyncIterator = AsyncIterator, exports.async = function (innerFn, outerFn, self, tryLocsList, PromiseImpl) { void 0 === PromiseImpl && (PromiseImpl = Promise); var iter = new AsyncIterator(wrap(innerFn, outerFn, self, tryLocsList), PromiseImpl); return exports.isGeneratorFunction(outerFn) ? iter : iter.next().then(function (result) { return result.done ? result.value : iter.next(); }); }, defineIteratorMethods(Gp), define(Gp, toStringTagSymbol, "Generator"), define(Gp, iteratorSymbol, function () { return this; }), define(Gp, "toString", function () { return "[object Generator]"; }), exports.keys = function (object) { var keys = []; for (var key in object) { keys.push(key); } return keys.reverse(), function next() { for (; keys.length;) { var key = keys.pop(); if (key in object) return next.value = key, next.done = !1, next; } return next.done = !0, next; }; }, exports.values = values, Context.prototype = { constructor: Context, reset: function reset(skipTempReset) { if (this.prev = 0, this.next = 0, this.sent = this._sent = undefined, this.done = !1, this.delegate = null, this.method = "next", this.arg = undefined, this.tryEntries.forEach(resetTryEntry), !skipTempReset) for (var name in this) { "t" === name.charAt(0) && hasOwn.call(this, name) && !isNaN(+name.slice(1)) && (this[name] = undefined); } }, stop: function stop() { this.done = !0; var rootRecord = this.tryEntries[0].completion; if ("throw" === rootRecord.type) throw rootRecord.arg; return this.rval; }, dispatchException: function dispatchException(exception) { if (this.done) throw exception; var context = this; function handle(loc, caught) { return record.type = "throw", record.arg = exception, context.next = loc, caught && (context.method = "next", context.arg = undefined), !!caught; } for (var i = this.tryEntries.length - 1; i >= 0; --i) { var entry = this.tryEntries[i], record = entry.completion; if ("root" === entry.tryLoc) return handle("end"); if (entry.tryLoc <= this.prev) { var hasCatch = hasOwn.call(entry, "catchLoc"), hasFinally = hasOwn.call(entry, "finallyLoc"); if (hasCatch && hasFinally) { if (this.prev < entry.catchLoc) return handle(entry.catchLoc, !0); if (this.prev < entry.finallyLoc) return handle(entry.finallyLoc); } else if (hasCatch) { if (this.prev < entry.catchLoc) return handle(entry.catchLoc, !0); } else { if (!hasFinally) throw new Error("try statement without catch or finally"); if (this.prev < entry.finallyLoc) return handle(entry.finallyLoc); } } } }, abrupt: function abrupt(type, arg) { for (var i = this.tryEntries.length - 1; i >= 0; --i) { var entry = this.tryEntries[i]; if (entry.tryLoc <= this.prev && hasOwn.call(entry, "finallyLoc") && this.prev < entry.finallyLoc) { var finallyEntry = entry; break; } } finallyEntry && ("break" === type || "continue" === type) && finallyEntry.tryLoc <= arg && arg <= finallyEntry.finallyLoc && (finallyEntry = null); var record = finallyEntry ? finallyEntry.completion : {}; return record.type = type, record.arg = arg, finallyEntry ? (this.method = "next", this.next = finallyEntry.finallyLoc, ContinueSentinel) : this.complete(record); }, complete: function complete(record, afterLoc) { if ("throw" === record.type) throw record.arg; return "break" === record.type || "continue" === record.type ? this.next = record.arg : "return" === record.type ? (this.rval = this.arg = record.arg, this.method = "return", this.next = "end") : "normal" === record.type && afterLoc && (this.next = afterLoc), ContinueSentinel; }, finish: function finish(finallyLoc) { for (var i = this.tryEntries.length - 1; i >= 0; --i) { var entry = this.tryEntries[i]; if (entry.finallyLoc === finallyLoc) return this.complete(entry.completion, entry.afterLoc), resetTryEntry(entry), ContinueSentinel; } }, catch: function _catch(tryLoc) { for (var i = this.tryEntries.length - 1; i >= 0; --i) { var entry = this.tryEntries[i]; if (entry.tryLoc === tryLoc) { var record = entry.completion; if ("throw" === record.type) { var thrown = record.arg; resetTryEntry(entry); } return thrown; } } throw new Error("illegal catch attempt"); }, delegateYield: function delegateYield(iterable, resultName, nextLoc) { return this.delegate = { iterator: values(iterable), resultName: resultName, nextLoc: nextLoc }, "next" === this.method && (this.arg = undefined), ContinueSentinel; } }, exports; }

function _createSuper(Derived) { var hasNativeReflectConstruct = _isNativeReflectConstruct(); return function _createSuperInternal() { var Super = _getPrototypeOf(Derived), result; if (hasNativeReflectConstruct) { var NewTarget = _getPrototypeOf(this).constructor; result = Reflect.construct(Super, arguments, NewTarget); } else { result = Super.apply(this, arguments); } return _possibleConstructorReturn(this, result); }; }

function _isNativeReflectConstruct() { if (typeof Reflect === "undefined" || !Reflect.construct) return false; if (Reflect.construct.sham) return false; if (typeof Proxy === "function") return true; try { Boolean.prototype.valueOf.call(Reflect.construct(Boolean, [], function () {})); return true; } catch (e) { return false; } }

(function (global, factory) {
  typeof exports === 'object' && typeof module !== 'undefined' ? factory(exports) : typeof define === 'function' && define.amd ? define(['exports'], factory) : (global = global || self, factory(global.estreeWalker = {}));
})(this, function (exports) {
  'use strict'; // @ts-check

  /** @typedef { import('estree').BaseNode} BaseNode */

  /** @typedef {{
  	skip: () => void;
  	remove: () => void;
  	replace: (node: BaseNode) => void;
  }} WalkerContext */

  var WalkerBase = /*#__PURE__*/function () {
    function WalkerBase() {
      var _this = this;

      _classCallCheck(this, WalkerBase);

      /** @type {boolean} */
      this.should_skip = false;
      /** @type {boolean} */

      this.should_remove = false;
      /** @type {BaseNode | null} */

      this.replacement = null;
      /** @type {WalkerContext} */

      this.context = {
        skip: function skip() {
          return _this.should_skip = true;
        },
        remove: function remove() {
          return _this.should_remove = true;
        },
        replace: function replace(node) {
          return _this.replacement = node;
        }
      };
    }
    /**
     *
     * @param {any} parent
     * @param {string} prop
     * @param {number} index
     * @param {BaseNode} node
     */


    _createClass(WalkerBase, [{
      key: "replace",
      value: function replace(parent, prop, index, node) {
        if (parent) {
          if (index !== null) {
            parent[prop][index] = node;
          } else {
            parent[prop] = node;
          }
        }
      }
      /**
       *
       * @param {any} parent
       * @param {string} prop
       * @param {number} index
       */

    }, {
      key: "remove",
      value: function remove(parent, prop, index) {
        if (parent) {
          if (index !== null) {
            parent[prop].splice(index, 1);
          } else {
            delete parent[prop];
          }
        }
      }
    }]);

    return WalkerBase;
  }(); // @ts-check

  /** @typedef { import('estree').BaseNode} BaseNode */

  /** @typedef { import('./walker.js').WalkerContext} WalkerContext */

  /** @typedef {(
   *    this: WalkerContext,
   *    node: BaseNode,
   *    parent: BaseNode,
   *    key: string,
   *    index: number
   * ) => void} SyncHandler */


  var SyncWalker = /*#__PURE__*/function (_WalkerBase) {
    _inherits(SyncWalker, _WalkerBase);

    var _super = _createSuper(SyncWalker);

    /**
     *
     * @param {SyncHandler} enter
     * @param {SyncHandler} leave
     */
    function SyncWalker(enter, leave) {
      var _this2;

      _classCallCheck(this, SyncWalker);

      _this2 = _super.call(this);
      /** @type {SyncHandler} */

      _this2.enter = enter;
      /** @type {SyncHandler} */

      _this2.leave = leave;
      return _this2;
    }
    /**
     *
     * @param {BaseNode} node
     * @param {BaseNode} parent
     * @param {string} [prop]
     * @param {number} [index]
     * @returns {BaseNode}
     */


    _createClass(SyncWalker, [{
      key: "visit",
      value: function visit(node, parent, prop, index) {
        if (node) {
          if (this.enter) {
            var _should_skip = this.should_skip;
            var _should_remove = this.should_remove;
            var _replacement = this.replacement;
            this.should_skip = false;
            this.should_remove = false;
            this.replacement = null;
            this.enter.call(this.context, node, parent, prop, index);

            if (this.replacement) {
              node = this.replacement;
              this.replace(parent, prop, index, node);
            }

            if (this.should_remove) {
              this.remove(parent, prop, index);
            }

            var skipped = this.should_skip;
            var removed = this.should_remove;
            this.should_skip = _should_skip;
            this.should_remove = _should_remove;
            this.replacement = _replacement;
            if (skipped) return node;
            if (removed) return null;
          }

          for (var key in node) {
            var value = node[key];

            if (typeof value !== "object") {
              continue;
            } else if (Array.isArray(value)) {
              for (var i = 0; i < value.length; i += 1) {
                if (value[i] !== null && typeof value[i].type === 'string') {
                  if (!this.visit(value[i], node, key, i)) {
                    // removed
                    i--;
                  }
                }
              }
            } else if (value !== null && typeof value.type === "string") {
              this.visit(value, node, key, null);
            }
          }

          if (this.leave) {
            var _replacement2 = this.replacement;
            var _should_remove2 = this.should_remove;
            this.replacement = null;
            this.should_remove = false;
            this.leave.call(this.context, node, parent, prop, index);

            if (this.replacement) {
              node = this.replacement;
              this.replace(parent, prop, index, node);
            }

            if (this.should_remove) {
              this.remove(parent, prop, index);
            }

            var _removed = this.should_remove;
            this.replacement = _replacement2;
            this.should_remove = _should_remove2;
            if (_removed) return null;
          }
        }

        return node;
      }
    }]);

    return SyncWalker;
  }(WalkerBase); // @ts-check

  /** @typedef { import('estree').BaseNode} BaseNode */

  /** @typedef { import('./walker').WalkerContext} WalkerContext */

  /** @typedef {(
   *    this: WalkerContext,
   *    node: BaseNode,
   *    parent: BaseNode,
   *    key: string,
   *    index: number
   * ) => Promise<void>} AsyncHandler */


  var AsyncWalker = /*#__PURE__*/function (_WalkerBase2) {
    _inherits(AsyncWalker, _WalkerBase2);

    var _super2 = _createSuper(AsyncWalker);

    /**
     *
     * @param {AsyncHandler} enter
     * @param {AsyncHandler} leave
     */
    function AsyncWalker(enter, leave) {
      var _this3;

      _classCallCheck(this, AsyncWalker);

      _this3 = _super2.call(this);
      /** @type {AsyncHandler} */

      _this3.enter = enter;
      /** @type {AsyncHandler} */

      _this3.leave = leave;
      return _this3;
    }
    /**
     *
     * @param {BaseNode} node
     * @param {BaseNode} parent
     * @param {string} [prop]
     * @param {number} [index]
     * @returns {Promise<BaseNode>}
     */


    _createClass(AsyncWalker, [{
      key: "visit",
      value: function () {
        var _visit = _asyncToGenerator( /*#__PURE__*/_regeneratorRuntime().mark(function _callee(node, parent, prop, index) {
          var _should_skip, _should_remove, _replacement, skipped, removed, key, value, i, _replacement3, _should_remove3, _removed2;

          return _regeneratorRuntime().wrap(function _callee$(_context) {
            while (1) {
              switch (_context.prev = _context.next) {
                case 0:
                  if (!node) {
                    _context.next = 61;
                    break;
                  }

                  if (!this.enter) {
                    _context.next = 21;
                    break;
                  }

                  _should_skip = this.should_skip;
                  _should_remove = this.should_remove;
                  _replacement = this.replacement;
                  this.should_skip = false;
                  this.should_remove = false;
                  this.replacement = null;
                  _context.next = 10;
                  return this.enter.call(this.context, node, parent, prop, index);

                case 10:
                  if (this.replacement) {
                    node = this.replacement;
                    this.replace(parent, prop, index, node);
                  }

                  if (this.should_remove) {
                    this.remove(parent, prop, index);
                  }

                  skipped = this.should_skip;
                  removed = this.should_remove;
                  this.should_skip = _should_skip;
                  this.should_remove = _should_remove;
                  this.replacement = _replacement;

                  if (!skipped) {
                    _context.next = 19;
                    break;
                  }

                  return _context.abrupt("return", node);

                case 19:
                  if (!removed) {
                    _context.next = 21;
                    break;
                  }

                  return _context.abrupt("return", null);

                case 21:
                  _context.t0 = _regeneratorRuntime().keys(node);

                case 22:
                  if ((_context.t1 = _context.t0()).done) {
                    _context.next = 47;
                    break;
                  }

                  key = _context.t1.value;
                  value = node[key];

                  if (!(typeof value !== "object")) {
                    _context.next = 29;
                    break;
                  }

                  return _context.abrupt("continue", 22);

                case 29:
                  if (!Array.isArray(value)) {
                    _context.next = 42;
                    break;
                  }

                  i = 0;

                case 31:
                  if (!(i < value.length)) {
                    _context.next = 40;
                    break;
                  }

                  if (!(value[i] !== null && typeof value[i].type === 'string')) {
                    _context.next = 37;
                    break;
                  }

                  _context.next = 35;
                  return this.visit(value[i], node, key, i);

                case 35:
                  if (_context.sent) {
                    _context.next = 37;
                    break;
                  }

                  // removed
                  i--;

                case 37:
                  i += 1;
                  _context.next = 31;
                  break;

                case 40:
                  _context.next = 45;
                  break;

                case 42:
                  if (!(value !== null && typeof value.type === "string")) {
                    _context.next = 45;
                    break;
                  }

                  _context.next = 45;
                  return this.visit(value, node, key, null);

                case 45:
                  _context.next = 22;
                  break;

                case 47:
                  if (!this.leave) {
                    _context.next = 61;
                    break;
                  }

                  _replacement3 = this.replacement;
                  _should_remove3 = this.should_remove;
                  this.replacement = null;
                  this.should_remove = false;
                  _context.next = 54;
                  return this.leave.call(this.context, node, parent, prop, index);

                case 54:
                  if (this.replacement) {
                    node = this.replacement;
                    this.replace(parent, prop, index, node);
                  }

                  if (this.should_remove) {
                    this.remove(parent, prop, index);
                  }

                  _removed2 = this.should_remove;
                  this.replacement = _replacement3;
                  this.should_remove = _should_remove3;

                  if (!_removed2) {
                    _context.next = 61;
                    break;
                  }

                  return _context.abrupt("return", null);

                case 61:
                  return _context.abrupt("return", node);

                case 62:
                case "end":
                  return _context.stop();
              }
            }
          }, _callee, this);
        }));

        function visit(_x, _x2, _x3, _x4) {
          return _visit.apply(this, arguments);
        }

        return visit;
      }()
    }]);

    return AsyncWalker;
  }(WalkerBase); // @ts-check

  /** @typedef { import('estree').BaseNode} BaseNode */

  /** @typedef { import('./sync.js').SyncHandler} SyncHandler */

  /** @typedef { import('./async.js').AsyncHandler} AsyncHandler */

  /**
   *
   * @param {BaseNode} ast
   * @param {{
   *   enter?: SyncHandler
   *   leave?: SyncHandler
   * }} walker
   * @returns {BaseNode}
   */


  function walk(ast, _ref) {
    var enter = _ref.enter,
        leave = _ref.leave;
    var instance = new SyncWalker(enter, leave);
    return instance.visit(ast, null);
  }
  /**
   *
   * @param {BaseNode} ast
   * @param {{
   *   enter?: AsyncHandler
   *   leave?: AsyncHandler
   * }} walker
   * @returns {Promise<BaseNode>}
   */


  function asyncWalk(_x5, _x6) {
    return _asyncWalk.apply(this, arguments);
  }

  function _asyncWalk() {
    _asyncWalk = _asyncToGenerator( /*#__PURE__*/_regeneratorRuntime().mark(function _callee2(ast, _ref2) {
      var enter, leave, instance;
      return _regeneratorRuntime().wrap(function _callee2$(_context2) {
        while (1) {
          switch (_context2.prev = _context2.next) {
            case 0:
              enter = _ref2.enter, leave = _ref2.leave;
              instance = new AsyncWalker(enter, leave);
              _context2.next = 4;
              return instance.visit(ast, null);

            case 4:
              return _context2.abrupt("return", _context2.sent);

            case 5:
            case "end":
              return _context2.stop();
          }
        }
      }, _callee2);
    }));
    return _asyncWalk.apply(this, arguments);
  }

  exports.asyncWalk = asyncWalk;
  exports.walk = walk;
  Object.defineProperty(exports, '__esModule', {
    value: true
  });
});